import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubProject } from 'src/app/model/project/sub-project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'client-sub-project-on-hold-content',
  templateUrl: './client-sub-project-on-hold-content.component.html',
  styleUrls: ['./client-sub-project-on-hold-content.component.scss'],
})
export class ClientSubProjectOnHoldContentComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  subProject: SubProject;

  @Output()
  save = new EventEmitter<any>();

  onHoldCheckboxModel: boolean = false;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.onHoldCheckboxModel = !this.subProject.onHold;
    this.addSubscription(
      this.projectDisplayObservableService.getSubProjectSetOnHoldSubscribable(),
      (id: number) => {
        if (id === this.subProject.id) {
          this.onHoldCheckboxModel = false;
          if (
            this.subProject.projectPlacement.appointment ||
            this.subProject.projectPlacement.collectKey
          ) {
            this.subProject.projectPlacement.firstAppointment = false;
          }
        }
      }
    );
  }

  onHoldReasonChanged(value: string): void {
    this.subProject.onHoldReason = value;
    this.save.emit();
  }

  onHoldHandlingChanged(value: string): void {
    this.subProject.onHoldHandling = value;
    this.save.emit();
  }

  onHoldCheckboxModelChanged(): void {
    this.subProject.onHold = !this.onHoldCheckboxModel;
    this.save.emit();
  }
}
